// extracted by mini-css-extract-plugin
export default {"SingleValue":"wJJHpHj2"};